import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { numeralFormat } from 'src/utils/misc';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { CashPlaceholder } from '../comps';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    height: 100%;

    &__item {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

interface FutureSecurityProgrammeProps {
  value: DashboardQuery['dashboard']['futureSecurityProgram'];
  state: AssessmentState;
}

export const FutureSecurityProgram: React.FC<FutureSecurityProgrammeProps> = ({ value, state }) => {
  return (
    <Wrap>
      <span className="c-title">Future Security Programme</span>

      <div className="grid">
        <div className="grid__item">
          <Poppins px={12} weight={500}>
            FURTHER REDUCTION
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>between live and projected risk</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="brightBlue" px={26} className="value">
              {numeralFormat(value?.furtherReduction)}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            ADDITIONAL COST
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>of the additional controls required to achieve this reduction</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="brightBlue" px={26} className="value">
              {numeralFormat(value?.additionalCost)}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            TOTAL SAVINGS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>as a result of the future security program</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <CashPlaceholder state={state} />
          ) : (
            <Poppins weight={600} color="brightBlue" px={26} className="value">
              {numeralFormat(value?.totalSavings)}
            </Poppins>
          )}
        </div>
      </div>
    </Wrap>
  );
};
